/**
 * Numérotation paramétrable des documents.
 * Référence : document 04 § 5.1 (`numbering_sequences`) et contrainte « numérotation sans rupture ».
 */
/** Jetons reconnus dans `numbering_sequences.pattern`. */
export const NUMBERING_PATTERN_TOKENS = ['prefix', 'year', 'month', 'counter', 'suffix'];
export const DEFAULT_NUMBERING_PATTERN = '{prefix}{year}{counter}';
export const NUMBERING_PADDING_MIN = 1;
export const NUMBERING_PADDING_MAX = 12;
export const NUMBERING_PADDING_DEFAULT = 5;
export const NUMBERING_YEAR_FORMATS = ['YYYY', 'YY'];
export const NUMBERING_MONTH_FORMATS = ['MM'];
export const NUMBERING_SEPARATORS = ['', '-', '/', '.', '_'];
/** Séquences livrées par défaut à la création d'une société. */
export const DEFAULT_NUMBERING_SEQUENCES = [
    {
        documentType: 'quote',
        prefix: 'DEV',
        pattern: '{prefix}-{year}-{counter}',
        padding: 5,
        resetYearly: true,
        isDefault: true,
    },
    {
        documentType: 'order',
        prefix: 'CMD',
        pattern: '{prefix}-{year}-{counter}',
        padding: 5,
        resetYearly: true,
        isDefault: true,
    },
    {
        documentType: 'invoice',
        prefix: 'FAC',
        pattern: '{prefix}-{year}-{counter}',
        padding: 5,
        resetYearly: true,
        isDefault: true,
    },
    {
        documentType: 'credit_note',
        prefix: 'AV',
        pattern: '{prefix}-{year}-{counter}',
        padding: 5,
        resetYearly: true,
        isDefault: true,
    },
    {
        documentType: 'deposit_invoice',
        prefix: 'ACO',
        pattern: '{prefix}-{year}-{counter}',
        padding: 5,
        resetYearly: true,
        isDefault: true,
    },
    {
        documentType: 'progress_invoice',
        prefix: 'SIT',
        pattern: '{prefix}-{year}-{counter}',
        padding: 5,
        resetYearly: true,
        isDefault: true,
    },
    {
        documentType: 'final_invoice',
        prefix: 'SOL',
        pattern: '{prefix}-{year}-{counter}',
        padding: 5,
        resetYearly: true,
        isDefault: true,
    },
    {
        documentType: 'prospect',
        prefix: 'PRO',
        pattern: '{prefix}{counter}',
        padding: 5,
        resetYearly: false,
        isDefault: true,
    },
    {
        documentType: 'client',
        prefix: 'CLI',
        pattern: '{prefix}{counter}',
        padding: 5,
        resetYearly: false,
        isDefault: true,
    },
    {
        documentType: 'opportunity',
        prefix: 'OP',
        pattern: '{prefix}{counter}',
        padding: 5,
        resetYearly: false,
        isDefault: true,
    },
];
/**
 * Compose un aperçu de numéro **sans consommer la séquence réelle**.
 * Référence : règle « les aperçus de numérotation ne doivent pas consommer la séquence ».
 */
export function previewNumber(pattern, options) {
    const date = options.date ?? new Date();
    const year = (options.yearFormat ?? 'YYYY') === 'YY'
        ? String(date.getUTCFullYear()).slice(-2)
        : String(date.getUTCFullYear());
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const counter = String(options.counter).padStart(options.padding, '0');
    return pattern
        .replaceAll('{prefix}', options.prefix ?? '')
        .replaceAll('{year}', year)
        .replaceAll('{month}', month)
        .replaceAll('{counter}', counter)
        .replaceAll('{suffix}', options.suffix ?? '');
}
//# sourceMappingURL=numbering.constants.js.map